import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { DashboardWidgetFC } from '@frontend/grid-dashboard';
import { BulkCampaignWidget, bulkCampaignWidgetSize } from './bulk-campaign-widget';

/**
 * @dashboard-widget
 *
 * id: bulk-texting-widget
 * title: Bulk Texting
 * description: Monitor your text allotment with a real-time progress bar and remaining message count display.
 * icon: cell-phone-small
 */
export const BulkTextingWidget: DashboardWidgetFC = () => {
  return <BulkCampaignWidget campaignType={CampaignType.SMS} />;
};

BulkTextingWidget.config = {
  size: bulkCampaignWidgetSize,
  feature: 'messaging',
};
